module.exports = __webpack_public_path__ + "static/media/comer-hero.b3040578.svg";